/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers';
import AppConst from '../AppLayout/const';
import { getPurchaseOrderReport } from '../../api/reportsApi';

export default function PurchaseOrderReportModal() {
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);

  const [fromValue, setFromValue] = useState(moment().format('YYYY-MM-DD'));
  const [toValue, setToValue] = useState(moment().format('YYYY-MM-DD'));

  useEffect(() => {
    if (toggleModal?.url === 'report/puchase_order') {
      setToggle(true);
    }
  }, [toggleModal]);

  const handleExport = async () => {
    try {
      toast.loading('Please wait ...');
      const res = await getPurchaseOrderReport({
        date_from: fromValue,
        date_to: toValue,
      });

      const { code, result } = res.data.response;
      if (code !== '200') {
        throw Object.assign(new Error('Encountered an error'), { code: 402 });
      }
      toast.dismiss();

      window.location.href = result;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleChangeFrom = (value) => {
    setFromValue(moment(value).format('YYYY-MM-DD'));
  };

  const handleChangeTo = (value) => {
    setToValue(moment(value).format('YYYY-MM-DD'));
  };

  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
  };
  return (
    <Dialog open={toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Purchase Order Report</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid xs={6}>
            <DatePicker
              label='from'
              views={['month', 'day', 'year']}
              value={fromValue}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='From' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeFrom(value)}
            />
          </Grid>
          <Grid xs={6}>
            <DatePicker
              label='to'
              views={['month', 'day', 'year']}
              value={toValue}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
              onChange={(value) => handleChangeTo(value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleExport}>Submit</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
